import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "d-flex align-items-center justify-content-center error-content" }
const _hoisted_2 = { class: "error" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h6", null, [
  /*#__PURE__*/_createElementVNode("span", null, "Sorry, You Are Not Allowed to Access This Page.")
], -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { key: 1 }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h6", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "p-1" })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FontAwesomeIcon = _resolveComponent("FontAwesomeIcon")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_FontAwesomeIcon, {
        style: {"color":"var(--bs-danger)"},
        icon: ['fas', 'triangle-exclamation'],
        size: "2x"
      }),
      (_ctx.pageError == '403')
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5))
        : (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("h6", null, [
              _createElementVNode("span", null, _toDisplayString(_ctx.pageError), 1)
            ]),
            _hoisted_7,
            _createVNode(_component_Button, {
              class: "p-button-sm p-button-secondary",
              onClick: _ctx.back,
              label: "Back"
            }, null, 8, ["onClick"])
          ]))
    ])
  ]))
}